import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "../../components";
import { SendOTP } from "../../utilities/api/auth/auth-service";
import { messages } from "../../utilities/Messages";

const DeleteAccount = () => {
  const [phoneNo, setPhoneNo] = useState(0);
  const [message, setMessage] = useState("");
  const [verifyBy, setVerifyBy] = useState("")
  const navigate = useNavigate();
  const getMessage = messages.auth;
  useEffect(() => {
    document.body.classList.add("forgot-page");
    return () => {
      document.body.classList.remove("forgot-page");
    };
  }, []);

  const DeleteAccount = async () => {
    if (verifyBy === "password") {
      navigate("/verify-delete-account", {
        state: {
          phone: phoneNo,
          verifyBy: verifyBy
        },
      });
    } else {
      const result = await SendOTP({ phone: phoneNo, otpFor: "deleteAccount" });
      if (result?.status === 200) {
        navigate("/verify-delete-account", {
          state: {
            message: result.data.message,
            otpNumber: result.data.data.otpNumber,
            phone: phoneNo,
            verifyBy: verifyBy
          },
        });
      }
      if (result?.response?.status === 400) {
        toast.error(result.response.data.message);
      }
    }

  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (phoneNo < 1000000000 || phoneNo > 10000000000) {
      setMessage(getMessage.otpFor_isEnum);
    } else {
      if (verifyBy === "") {
        toast.error(getMessage.verifyBy_required);
      } else {
        DeleteAccount();
      }

    }
  };
  return (
    <>
      <div className="container">
        <div className="row justify-content-center align-items-center bg-height">
          <div className="col-md-5">
            <div className="card">
              <div className="card-body">
                <form>
                  <h3 className="card-title mb-4 text-start">
                    Delete Account
                  </h3>

                  <div className="mb-3 text-start">
                    <label htmlFor="number" className="form-label">
                      Phone Number <small className="text-danger">*</small>
                    </label>
                    <Input
                      onChange={(e: any) => setPhoneNo(e.target.value)}
                      type="number"
                      placeholder="Enter Phone Number"
                      id="number"
                      name="number"
                      className="form-control"
                      onKeyDown={(e: any) =>
                        ["e", ".", "-", "+"].includes(e.key) &&
                        e.preventDefault()
                      }
                      onWheel={(e: any) => e.target.blur()}
                    />
                    <span className="error-msg"> {message}</span>
                  </div>
                  <div >

                    <div className="">
                      <label htmlFor="number" className="form-label">
                        Select Verify Option <small className="text-danger">*</small>
                      </label>
                    </div>

                    <div className="form-check form-check-inline col-md-4 ">
                      <input className="form-check-input" onChange={(e: any) => {
                        setVerifyBy(e.target.value)
                      }} type="radio" name="inlineRadioOptions" id="inlineRadio1" value="otpNumber" />
                      <label className="form-check-label" htmlFor="inlineRadio1">Verify by OTP</label>
                    </div>
                    <div className="form-check form-check-inline col-md-6">
                      <input className="form-check-input" onChange={(e: any) => {
                        setVerifyBy(e.target.value)
                      }} type="radio" name="inlineRadioOptions" id="inlineRadio2" value="password" />
                      <label className="form-check-label" htmlFor="inlineRadio2">Verify by Password</label>
                    </div>
                  </div>

                  <div className="row align-items-center">
                    {/* <div className="col-md-6 text-start">
                      <NavLink to="/">Back to Login</NavLink>
                    </div> */}

                    <div className="col-md-12 text-end mt-3">
                      <Button
                        onClick={handleSubmit}
                        bname="Submit"
                        name="forgot-password"
                        id="forgot-password"
                        className="btn btn-primary rounded-1"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>


          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
export { DeleteAccount };
